<template>
  <div class="verify">
    <v-card class="verify__card">
      <v-card-text v-if="status === 'pending'">{{ $t("booking.verifying_email") }}</v-card-text>
      <v-card-text v-else-if="status === 'success'">
        <v-icon icon="mdi-check-circle" color="success" size="large" />
        <p>{{ $t("booking.email_verified") }}</p>
      </v-card-text>
      <v-card-text v-else>
        <v-icon icon="mdi-alert-circle" color="error" size="large" />
        <p>{{ $t("booking.verification_link_invalid") }}</p>
      </v-card-text>
    </v-card>
  </div>
</template>

<script lang="ts" setup>
import { onMounted, ref } from "vue";
import { useRoute } from "vue-router";
import { getGuestProfile, verifyGuestEmail } from "../../services/public-booking-api.service";
import { useGuestStore } from "../../stores/guest.store";

const route = useRoute();
const guestStore = useGuestStore();
const status = ref<"pending" | "success" | "error">("pending");

onMounted(async () => {
  try {
    await verifyGuestEmail(route.params.token as string);
    status.value = "success";

    // If the verifying browser also holds the guest's session (the common case —
    // they clicked the link in the same browser), refresh the cached profile so
    // the booking page's "please verify" gate clears without a manual re-login.
    if (guestStore.guestUser) {
      try {
        guestStore.setGuestUser(await getGuestProfile());
      } catch {
        // Not fatal — the booking page re-checks this itself on next visit.
      }
    }
  } catch {
    status.value = "error";
  }
});
</script>

<style lang="scss" scoped>
@use "../../styles/_breakpoints" as bp;

.verify {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  height: 100dvh;
  padding: 16px;

  &__card {
    max-width: 420px;
    text-align: center;
    padding: 24px;

    @include bp.small-phone {
      padding: 20px 16px;
    }
  }
}
</style>
